import styled from '@emotion/styled';
import Button from '@shared/components/core/button/CoreButton';
import TextButton from '@shared/components/core/button/TextButton';
import { BodyMedium, DisplayLarge, LabelMedium, TextSize300, TextSize90, TitleMedium, TitleSmall } from './Typography';
/**
 * ContentTypography.tsx
 *
 * This file contains the typography components for the content of the page.
 * They include additional padding and margins to help with the layout of the page.
 * For core typography see Typography.tsx
 */

export const ContentLayout = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 3rem 2rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
`;

export const CenteredContentLayout = styled(ContentLayout)`
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
`;

export const ContentQuickWrap = styled.div`
    flex-direction: column;
    display: flex;
    flex-wrap: wrap;
    margin: 2rem 0;
`;

export const PageTitle = styled(DisplayLarge)`
    padding: 0.5rem 0;
`;
export const ContentLabelMedium = styled(LabelMedium)`
    padding: 1rem 0 0.5rem 0;
`;
export const ContentTitle = styled(TitleMedium)`
    padding: 2rem 0 0.5rem 0;
`;
export const ContentTitleSmall = styled(TitleSmall)`
    padding: 1rem 0 0.5rem 0;
`;
export const SecondaryText = styled(BodyMedium)`
    color: ${(props) => props.theme.color.textBody};
    display: inline-block;
`;
export const ContentButton = styled(Button)`
    margin: 2rem 0;
`;
export const ContentTextButton = styled(TextButton)`
    display: inline-block;
    padding-left: 0.5rem;
`;

export const ContentText = styled(BodyMedium)`
    padding: 0rem 0 0.5rem 0;
`;

export const ContentTextSmall = styled(BodyMedium)`
    padding: 0rem 0 0.5rem 0;
`;

export const ContentTitleThin = styled(TitleSmall)`
    padding: 0rem 0 1rem 0;
    font-weight: 300;
`;

export const InlineButton = styled(TextButton)`
    font-weight: 700;
    ${TextSize300}
    color: ${(props) => props.theme.color.text};
    :hover {
        color: ${(props) => props.theme.color.link};
    }
`;

export const Tag = styled.div`
    display: block;
    margin: 0.5rem 0;
    width: min-content;
    color: ${(props) => props.theme.tag.text};
    background-color: ${(props) => props.theme.tag.background};
    padding: 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 0.375rem;
`;

export const MobileOnlyTag = styled(Tag)`
    margin-left: 5px;
    display: inline-block;
    white-space: nowrap;
    ${TextSize90}
`;
